// extracted by mini-css-extract-plugin
module.exports = {"whatsOnTvContainer":"styles_whatsOnTvContainer__3OlWJ"};